<template>
    <div v-in-viewport="fetchData" class="flex flex-col">
        <graph-title
            :title="$t(`analytics.info.job_reasons.${rejected ? 'reject' : 'request'}.title`)"
            :description="$t(`analytics.info.job_reasons.${rejected ? 'reject' : 'request'}.description`)"
        />

        <div>
            <div v-if="fetching" class="h-336 w-full flex items-center justify-center">
                <loading color="blue" size="small"></loading>
            </div>
            <div v-else class="w-full">
                <div v-if="graphData.count">
                    <custom-legend
                        :items="tabs"
                        :colors="tabs.map(tab => getTabColor(tab))"
                        clickable
                        :selected-tab="selectedTab"
                        @update="handleUpdateChart"
                        :parent-ref="graphRef"
                        translation-key="analytics.filter_labels"
                    />
                    <div class="h-full relative">
                        <apex-charts
                            :ref="'jobReasons' + (rejected ? 'Rejected' : 'Requested')"
                            type="bar"
                            :height="75 + seriesDataLength * 30"
                            width="100%"
                            :options="chartOptions"
                            :series="series"
                        ></apex-charts>
                    </div>
                </div>
                <div v-else class="flex flex-col px-10">
                    <span class="text-center italic my-16">{{ $t('analytics.empty_series') }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AnalyticsMixins from "../../mixins/analyticsMixins";
import GraphTitle from "./GraphTitle";
import CustomLegend from "./CustomLegend.vue";
import Loading from "../ui/Loading";
import ApexCharts from "vue-apexcharts";
import chartOptions from '../../config/apex-charts';
import SvgIcon from '../ui/SvgIcon';
import * as analytics from "../../services/AnalyticsService";

export default {
    name: 'JobReasons',
    components: {
        CustomLegend,
        Loading,
        ApexCharts,
        SvgIcon,
        GraphTitle,
    },
    props: {
        rejected: {type: Boolean, default: false},
        filterFields: Object,
    },
    mixins: [AnalyticsMixins],
    data() {
        return {
            chartOptions: {
                ...chartOptions,
                chart: {
                    ...chartOptions.chart,
                    stacked: true,
                    redrawOnParentResize: true,
                    selection: {
                        stroke: {
                            width: 1,
                        }
                    },
                },
                colors: ['#00E396', '#008FFB', '#FEB019'],
                plotOptions: {
                    ...chartOptions.plotOptions,
                    bar: {
                        ...chartOptions.plotOptions.bar,
                        horizontal: true,
                        dataLabels: {
                            total: {
                                enabled: true,
                            }
                        }
                    },
                },
                legend: {
                    show: false,
                },
            },
            tabs: [
                'published',
                'unpublished',
                'archived'
            ],
        }
    },
    methods: {
        async fetchData(fresh = true) {
            if (!this.sendRequest() && !fresh) {
                this.fetching = false;
                return;
            }
            try {
                this.graphData = await analytics.jobReasons(this.filterFields, this.rejected);
                this.buildChart(this.graphData);
            } catch (error) {
                console.error(error);
                this.fetching = false;
            }
        },
        buildChart(graphData) {
            if (!graphData) {
                this.fetching = false;
                this.series = [];
                return;
            }
            this.series = JSON.parse(JSON.stringify(graphData.data));
            this.fetching = false;
            this.$nextTick(() => {
                this.graphRef = this.$refs[`jobReasons${this.rejected ? 'Rejected' : 'Requested'}`];
                if (this.graphRef) {
                    this.setDownloadButtonId(
                        this.graphRef,
                        `downloadChartJobReasons${this.rejected ? 'Rejected' : 'Requested'}`
                    );
                }
            });
        }
    },
}
</script>
